import PropTypes from 'prop-types';
import React from 'react';
import { Backdrop } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// This tiny component is meant to avoid rendering the Backdrop even when not visible
const Loader = ({ visible }) => {
  const theme = useTheme();
  if (!visible) {
    return null;
  }
  return (
    <Backdrop
      data-testid="backdrop"
      open
      sx={{
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
        // By using a zIndex higher than the tooltip we make sure the Loader's value is the highest in the application
        zIndex: theme.zIndex.tooltip + 1,
      }}
    />
  );
};

Loader.propTypes = {
  visible: PropTypes.bool,
};

Loader.defaultProps = {
  visible: false,
};

export default Loader;
